import ScreenBestCombos from '../../common/best-combos/ScreenBestCombos';
import css from './ScreenLookSetup.module.scss';

const ScreenLookSetup = () => {
    return <ScreenBestCombos pageTitle="Докручивай образ под себя" urlPath="popular" />;
};

export default ScreenLookSetup;
